export class MobiSimRegistrationToken {
  static IMobiSimRegistrationRepository = Symbol(
    "IMobiSimRegistrationRepository",
  );
  static MobiSimRegistrationViewModel = Symbol("MobiSimRegistrationViewModel");
  static MobiSimRegistrationUseCase = Symbol("MobiSimRegistrationUseCase");
}
